import type { JswOnboardingData } from '@jira/platform__onboarding-core/src/common/types/onboarding-data.tsx';
import {
	createResource,
	useResource,
	type RouteResource,
	type UseResourceHookResponse,
} from '@atlassian/react-resource-router';

const RESOURCE_TYPE_SOFTWARE_ONBOARDING = 'RESOURCE_TYPE_SOFTWARE_ONBOARDING';

export const jswOnboardingResource: RouteResource<JswOnboardingData | null> =
	createResource<JswOnboardingData | null>({
		type: RESOURCE_TYPE_SOFTWARE_ONBOARDING,
		getKey: () => 'jsw_onboarding',
		getDataLoader: () =>
			import(
				/* webpackChunkName: "async-resource-jsw-onboarding", jiraSpaEntry: "async-resource-jsw-onboarding" */ './getData.tsx'
			),
	});

export const useJswOnboardingResource = (): UseResourceHookResponse<JswOnboardingData | null> =>
	useResource<JswOnboardingData | null>(jswOnboardingResource);
